import { BRAND_SECONDARY } from "../../../utils/Styles";
import * as React from "react";
import {
  ActivityItem,
  mergeStyleSets,
  Persona,
  PersonaSize,
  Stack,
  TooltipHost,
} from "office-ui-fabric-react";
import { ICustomerReportWorkFlowLog } from "../../../vm";
import moment from "moment";
import { mdiCloseCircle, mdiBookmark, mdiCheckDecagram } from "@mdi/js";
import Icon from "@mdi/react";
import { ADMIN_ROLES_DIC, ROLES_DIC } from "../../common/Constants";

const classNames = mergeStyleSets({
  exampleRoot: {
    marginTop: "20px",
  },
  nameText: {
    fontWeight: "bold",
    fontSize: "12px",
    color: BRAND_SECONDARY,
  },
});

const STATUS_DICT: any = {
  "-5": " cancelled CEM report approval",
  "-4": " rejected this report",
  "-3": " rejected this report",
  "-2": " rejected this report",
  0: " generated report",
  1: " submitted this report for approval",
  2: " approved this report",
  3: " approved this report",
  4: " approved this report",
  5: " send email to customer",
  6: " generated merged report",
};

// const tooltipProps: ITooltipProps = {
//   onRenderContent: () => (
//     <ul style={{ margin: 10, padding: 0 }}>
//       <li>1. One</li>
//       <li>2. Two</li>
//     </ul>
//   ),
// };

export const WorkFlowLogs: React.FC<{
  data: Array<ICustomerReportWorkFlowLog>;
  dcDict: any;
}> = ({ data, dcDict }) => {
  // local state
  const [activityItemData, setActivityItemData] = React.useState([]);
  // local hooks

  React.useEffect(() => {
    generateLogs();
  }, [data]);
  const generateLogs = () => {
    const tempList: any = data.reverse().map((d, index) => {
      return {
        key: index + 1,
        activityDescription: [
          <TooltipHost
            key={d._id}
            tooltipProps={{
              onRenderContent: () => (
                <Stack>
                  <Stack.Item>
                    <Persona
                      initialsColor={BRAND_SECONDARY}
                      text={d?.modifiedBy?.name || ""}
                      secondaryText={
                        (d?.modifiedBy?.isAdmin === true
                          ? ADMIN_ROLES_DIC[d?.modifiedBy?.role]
                          : ROLES_DIC[d?.modifiedBy?.role]) +
                        (d.datacenterId
                          ? " | " + dcDict[d.datacenterId as string]?.name
                          : "")
                      }
                      size={PersonaSize.size48}
                    />
                  </Stack.Item>
                  {/* <Stack.Item>
                    <Text>
                      {dcDict[d?.datacenterId as string]?.name +
                        "-" +
                        dcDict[d?.datacenterId as string]?.location}
                    </Text>
                  </Stack.Item> */}
                </Stack>
              ),
            }}
          // style={{ width:  }}
          >
            <span
              key={1}
              className={classNames.nameText}
            // onClick={() => {
            //   alert('A name was clicked.');
            // }}
            >
              {d?.modifiedBy?.name || ""}
            </span>
          </TooltipHost>,
          //   <span key={1}>{d.modifiedBy.name}</span>,
          <span key={2}>
            {STATUS_DICT[d.status < 0 ? String(d.status) : d.status]}
          </span>,
        ],
        activityIcon: <StatusIcon status={d.status as number} />,
        comments: d.remarks ? [<span key={1}>{d.remarks}</span>] : [],
        timeStamp:
          moment().diff(moment(d.createdAt), "month") > 1
            ? moment(d.createdAt).format("Do MMM, YYYY")
            : moment(d.createdAt).fromNow(),
      };
    });
    setActivityItemData(tempList);
  };

  return (
    <div>
      {activityItemData.map((item: { key: string | number }) => (
        <ActivityItem
          {...item}
          key={item.key}
          className={classNames.exampleRoot}
        />
      ))}
    </div>
  );
};

const StatusIcon: React.FC<{ status: number }> = ({ status }) => {
  if (status > 0 && status !== 6) {
    return (
      <Icon
        path={mdiCheckDecagram}
        size={0.8}
        className="pointer"
        color={BRAND_SECONDARY}
      />
    );
  } else if (status < 0) {
    return (
      <Icon
        path={mdiCloseCircle}
        size={0.8}
        className="pointer"
        color={"#d62828"}
      />
    );
  }
  return (
    <Icon path={mdiBookmark} size={0.8} className="pointer" color={BRAND_SECONDARY} />
  );
};
